import {
    ConclusionKeys,
    FindingAreasEnum,
    QuestionnaireFlowType,
    getFindingAreaDisplayText,
    zodQuestionTypes
} from "../surveyStatusSchemas";

const questionnaireNMW: QuestionnaireFlowType = {
    id: FindingAreasEnum.NationalMinimumWage,
    name: getFindingAreaDisplayText(FindingAreasEnum.NationalMinimumWage),
    questions: [
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q1`,
            text: "Do you pay all employees at a rate that is equal to or higher than statutory National Minimum Wage ('NMW')?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q2A`,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q2A`,
            text: "Do you have policies/processes in place to monitor this?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q3A`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q3B`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q3A`,
            text: "Other than statutory, do you take any deductions from employee pay?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q4A`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q3B`,
            text: "Other than statutory, do you take any deductions from employee pay?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q4C`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q4D`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q4A`,
            text: "Do you require employees to wear specific items of their own clothing (e.g., black trousers) which they pay for personally?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q5A`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q5B`
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q4B`,
            text: "Do you require employees to wear specific items of their own clothing (e.g., black trousers) which they pay for personally?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q5C`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q5D`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q4C`,
            text: "Do you require employees to wear specific items of their own clothing (e.g., black trousers) which they pay for personally?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q5E`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q5F`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q4D`,
            text: "Do you require employees to wear specific items of their own clothing (e.g., black trousers) which they pay for personally?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NationalMinimumWage}:Q5G`,
                no: `${FindingAreasEnum.NationalMinimumWage}:Q5H`,
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5A`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: `${FindingAreasEnum.NationalMinimumWage}:Q6A`
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6A`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5B`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: `${FindingAreasEnum.NationalMinimumWage}:Q6B`
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6B`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5C`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: `${FindingAreasEnum.NationalMinimumWage}:Q6C`
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6C`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5D`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {next: `${FindingAreasEnum.NationalMinimumWage}:Q6D`},
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6D`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Green
            }
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5E`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {next: `${FindingAreasEnum.NationalMinimumWage}:Q6E`},
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6E`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5F`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: `${FindingAreasEnum.NationalMinimumWage}:Q6F`
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6F`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5G`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {next: `${FindingAreasEnum.NationalMinimumWage}:Q6G`},
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6G`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Red,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q5H`,
            text: "Is there any working time that employees are not paid for? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {next: `${FindingAreasEnum.NationalMinimumWage}:Q6H`},
        },
        {
            id: `${FindingAreasEnum.NationalMinimumWage}:Q6H`,
            text: "Are employees paid for breaks?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Amber
            },
        },
    ],
};

export default questionnaireNMW;
